export default "__VITE_ASSET__ZWhBS_SA__"